import { useState, useEffect } from "react";
import { Input, Button, Card, Typography, Spin, message, Table } from "antd";
import axios from "axios";
import { toaster } from "evergreen-ui";
import { BASE_URL } from "../../utils/cookies.config";

export default function Influencer() {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [stats, setStats] = useState([]);

  const handleSearch = async () => {
    if (code.toLowerCase() === "all") {
      setStats(data);
    } else {
      const nData = data.find(
        (item) => item._id.toLowerCase() === code.toLowerCase()
      );
      setStats([nData]);
    }
  };

  const getDiscounts = async () => {
    try {
      const response = await axios.get(BASE_URL + "/discounts/all/stats");
      setStats([]);
      setData(response.data);
      // console.log("polls:", userPolls)
    } catch (error) {
      console.error("Error fetching polls:", error);
      toaster.danger("Failed to fetch polls");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDiscounts();
  }, []);

  const SubTable = ({ entries }) => {
    const subColumns = [
      {
        title: "Event",
        dataIndex: ["_id", "event"],
        key: "event",
        sorter: (a, b) => a._id.event.localeCompare(b._id.event),
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: (a, b) => a.total - b.total,
      },
    ];

    return (
      <Table
        columns={subColumns}
        dataSource={entries.map((e, i) => ({ key: i, ...e }))}
        pagination={false}
        size="small"
      />
    );
  };

  const mainColumns = [
    {
      title: "Discount Code",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Total Entries",
      key: "total",
      render: (_, record) => record.entries.reduce((a, b) => a + b.total, 0),
    },
  ];

  return (
    <div style={{ maxWidth: 500, margin: "50px auto", textAlign: "center" }}>
      <Typography.Title level={2}>Influencer Statistics</Typography.Title>
      <Typography.Text type="secondary">
        Enter your discount code to view performance
      </Typography.Text>

      <div style={{ marginTop: 20, display: "flex", gap: 8 }}>
        <Input.Search
          placeholder="Enter discount code (e.g. WILDOUT25)"
          value={code}
          enterButton="Search"
          onSearch={handleSearch}
          onChange={(e) => setCode(e.target.value)}
          onPressEnter={handleSearch}
        />
      </div>

      <div style={{ marginTop: 30 }}>{loading && <Spin size="large" />}</div>
      <Table
        columns={mainColumns}
        dataSource={stats.map((item) => ({
          key: item._id,
          ...item,
        }))}
        bordered
        expandable={{
          expandedRowRender: (record) => <SubTable entries={record.entries} />,
          rowExpandable: (record) => record.entries.length > 0,
        }}
      />
    </div>
  );
}
